export default "__VITE_ASSET__BSgJO53K__"